// Generated by scripts/referentiel/extract.mjs — do not edit by hand.
//
// Référentiel d’éducation à la philosophie et à la citoyenneté
// https://ifpc-fwb.be/v5/documents/tc/refEPC.pdf
// SHA-256 7ac20e761b05ab671cd6ff9b723a4c473b170cc592ad19288cf6c5823dcd7892
// P3: pages 36-40, extractor v1

import type { Attendu } from './types.ts';

export const ATTENDUS: readonly Attendu[] = [
  {
    id: "EPC-P3-d5d52716",
    champ: "",
    section: "1. Élaborer un questionnement philosophique",
    kind: "Savoir-faire",
    parent: "À partir de l'étonnement et face à des réalités complexes du monde, formuler des questions à portée philosophique.",
    text: "Formuler son étonnement (parole, dessin, geste…) à propos de situations, de problèmes.",
  },
  {
    id: "EPC-P3-796fa3d9",
    champ: "",
    section: "1. Élaborer un questionnement philosophique",
    kind: "Savoir-faire",
    parent: "Recourir à l'imagination pour élargir le questionnement.",
    text: "Exprimer un étonnement à partir de l'imagination (exemple, illustration, évocation…).",
  },
  {
    id: "EPC-P3-a18c2f69",
    champ: "",
    section: "1. Élaborer un questionnement philosophique",
    kind: "Compétence",
    parent: "Élaborer un questionnement philosophique.",
    text: "À partir d'une situation réelle ou imaginaire, formuler un étonnement pour en dégager une question.",
  },
  {
    id: "EPC-P3-471ac467",
    champ: "",
    section: "2. Assurer la cohérence de sa pensée",
    kind: "Savoir",
    parent: "Stéréotype-préjugé.",
    text: "Identifier-exemplifier des stéréotypes, des préjugés.",
  },
  {
    id: "EPC-P3-56e1bf4b",
    champ: "",
    section: "2. Assurer la cohérence de sa pensée",
    kind: "Savoir",
    parent: "Le vrai, le beau, le juste, le bien, le bon.",
    text: "Identifier-exemplifier et faire dialoguer les concepts entre eux.",
  },
  {
    id: "EPC-P3-87b6ebb7",
    champ: "",
    section: "2. Assurer la cohérence de sa pensée",
    kind: "Savoir",
    parent: "Opinion-argument.",
    text: "Identifier-exemplifier divers avis sur une question.",
  },
  {
    id: "EPC-P3-bc10c3e2",
    champ: "",
    section: "2. Assurer la cohérence de sa pensée",
    kind: "Savoir-faire",
    parent: "Reconstruire des concepts liés à la philosophie et la citoyenneté.",
    text: "Donner des exemples et/ou des contrexemples d'un concept lié à la philosophie et à la citoyenneté.",
  },
  {
    id: "EPC-P3-43c89c4c",
    champ: "",
    section: "2. Assurer la cohérence de sa pensée",
    kind: "Savoir-faire",
    parent: "Identifier des erreurs de raisonnement.",
    text: "Identifier des stéréotypes.",
  },
  {
    id: "EPC-P3-0eb47e73",
    champ: "",
    section: "2. Assurer la cohérence de sa pensée",
    kind: "Savoir-faire",
    parent: "Distinguer faits, normes, valeurs.",
    text: "Distinguer les faits, ce que j’en sais, ce que j’en pense.",
  },
  {
    id: "EPC-P3-e2f8db9e",
    champ: "",
    section: "2. Assurer la cohérence de sa pensée",
    kind: "Compétence",
    parent: "Assurer la cohérence de sa pensée.",
    text: "Organiser ses idées pour construire des concepts liés à la philosophie et à la citoyenneté.",
  },
  {
    id: "EPC-P3-319aaa81",
    champ: "",
    section: "3. Prendre position de manière argumentée",
    kind: "Savoir-faire",
    parent: "Se positionner sur des questions philosophiques liées à la citoyenneté.",
    text: "Expliquer son avis-clarifier sa pensée.",
  },
  {
    id: "EPC-P3-20f635b9",
    champ: "",
    section: "3. Prendre position de manière argumentée",
    kind: "Savoir-faire",
    parent: "Se décentrer pour comprendre le point de vue d'autrui.",
    text: "Questionner l'autre pour obtenir des précisions.",
  },
  {
    id: "EPC-P3-1bb667b0",
    champ: "",
    section: "3. Prendre position de manière argumentée",
    kind: "Savoir-faire",
    parent: "Se décentrer pour comprendre le point de vue d'autrui.",
    text: "Répondre aux propos d’autrui.",
  },
  {
    id: "EPC-P3-38559ff2",
    champ: "",
    section: "3. Prendre position de manière argumentée",
    kind: "Compétence",
    parent: "Prendre position de manière argumentée.",
    text: "Expliquer son avis sur des questions de type philosophique liées à la citoyenneté.",
  },
  {
    id: "EPC-P3-866ab340",
    champ: "",
    section: "4. Développer son autonomie affective",
    kind: "Savoir",
    parent: "Émotions-sentiments.",
    text: "Identifier-exemplifier.",
  },
  {
    id: "EPC-P3-c541db2d",
    champ: "",
    section: "4. Développer son autonomie affective",
    kind: "Savoir",
    parent: "Intimité.",
    text: "Identifier-exemplifier ce qui relève de l’intimité.",
  },
  {
    id: "EPC-P3-57cc48ae",
    champ: "",
    section: "4. Développer son autonomie affective",
    kind: "Savoir",
    parent: "Consentement-refus.",
    text: "Identifier le consentement et le refus.",
  },
  {
    id: "EPC-P3-76648f05",
    champ: "",
    section: "4. Développer son autonomie affective",
    kind: "Savoir",
    parent: "Besoin-envie-désir.",
    text: "Identifier-exemplifier : distinguer et confronter ses besoins et ses désirs.",
  },
  {
    id: "EPC-P3-1efa6775",
    champ: "",
    section: "4. Développer son autonomie affective",
    kind: "Savoir",
    parent: "Genre-identité de genre-orientation sexuelle.",
    text: "Identifier-exemplifier des stéréotypes de genre.",
  },
  {
    id: "EPC-P3-e699af7a",
    champ: "",
    section: "4. Développer son autonomie affective",
    kind: "Savoir-faire",
    parent: "Réfléchir sur les affects et leurs effets sur le comportement.",
    text: "Identifier, exprimer et interroger la honte, la fierté, l’amour, la jalousie, l’indignation, la culpabilité… et leurs effets sur le comportement.",
  },
  {
    id: "EPC-P3-de6c27b5",
    champ: "",
    section: "4. Développer son autonomie affective",
    kind: "Savoir-faire",
    parent: "Préserver son intimité, son intégrité et celles des autres.",
    text: "Exprimer ses limites en vue de préserver son intimité, son intégrité physique et morale ainsi que respecter celles des autres.",
  },
  {
    id: "EPC-P3-bdb9140b",
    champ: "",
    section: "4. Développer son autonomie affective",
    kind: "Savoir-faire",
    parent: "Préserver son intimité, son intégrité et celles des autres.",
    text: "Questionner et dégager des pratiques pour préserver sa sécurité, son identité numérique et son intimité sur Internet.",
  },
  {
    id: "EPC-P3-d3c81f31",
    champ: "",
    section: "4. Développer son autonomie affective",
    kind: "Savoir-faire",
    parent: "Différencier besoins et désirs.",
    text: "Exprimer et interroger ses besoins et ses désirs.",
  },
  {
    id: "EPC-P3-37ba09f0",
    champ: "",
    section: "4. Développer son autonomie affective",
    kind: "Compétence",
    parent: "Développer son autonomie affective.",
    text: "Réfléchir sur ses affects ainsi que sur l’intégrité physique et morale.",
  },
  {
    id: "EPC-P3-d26b5cc6",
    champ: "",
    section: "5. S’ouvrir à la pluralité des cultures et des convictions",
    kind: "Savoir",
    parent: "Règle-loi-norme.",
    text: "Identifier-exemplifier : distinguer différents types de règles et de normes.",
  },
  {
    id: "EPC-P3-5ad41dc5",
    champ: "",
    section: "5. S’ouvrir à la pluralité des cultures et des convictions",
    kind: "Savoir",
    parent: "Culture(s)/multiculturalité.",
    text: "Identifier-exemplifier des manifestations de la multiculturalité.",
  },
  {
    id: "EPC-P3-cc067238",
    champ: "",
    section: "5. S’ouvrir à la pluralité des cultures et des convictions",
    kind: "Savoir-faire",
    parent: "Reconnaitre la pluralité des valeurs pour vivre en société dans le respect mutuel.",
    text: "Identifier ce qui compte pour soi et ce qui compte pour les autres.",
  },
  {
    id: "EPC-P3-a898b310",
    champ: "",
    section: "5. S’ouvrir à la pluralité des cultures et des convictions",
    kind: "Savoir-faire",
    parent: "Reconnaitre le rôle et la pluralité des normes.",
    text: "Distinguer les usages, les règles de vie, les lois.",
  },
  {
    id: "EPC-P3-ce0af05d",
    champ: "",
    section: "5. S’ouvrir à la pluralité des cultures et des convictions",
    kind: "Savoir-faire",
    parent: "Reconnaitre le caractère multiculturel de notre société.",
    text: "Identifier des manifestations du caractère multiculturel de notre société.",
  },
  {
    id: "EPC-P3-dca9c7d5",
    champ: "",
    section: "5. S’ouvrir à la pluralité des cultures et des convictions",
    kind: "Compétence",
    parent: "S’ouvrir à la pluralité des cultures et des convictions.",
    text: "Identifier la pluralité des préférences et des règles.",
  },
  {
    id: "EPC-P3-866ab340-2",
    champ: "",
    section: "6. Comprendre les principes de la démocratie",
    kind: "Savoir",
    parent: "Liberté-égalité de droits (Déclaration universelle des droits de l’homme-Convention internationale des droits de l’enfant).",
    text: "Identifier-exemplifier.",
  },
  {
    id: "EPC-P3-8d17b3f8",
    champ: "",
    section: "6. Comprendre les principes de la démocratie",
    kind: "Savoir",
    parent: "Citoyen-citoyenneté.",
    text: "Voir attendu de savoir-faire : « S’identifier comme citoyen en dégageant les caractéristiques de la citoyenneté ».",
  },
  {
    id: "EPC-P3-db5bb5a9",
    champ: "",
    section: "6. Comprendre les principes de la démocratie",
    kind: "Savoir-faire",
    parent: "Reconnaitre tout citoyen comme auteur et bénéficiaire de la loi et comme sujet de droit.",
    text: "S’identifier comme citoyen en dégageant des caractéristiques de la citoyenneté.",
  },
  {
    id: "EPC-P3-d104e8b7",
    champ: "",
    section: "6. Comprendre les principes de la démocratie",
    kind: "Savoir-faire",
    parent: "Reconnaitre tout citoyen comme auteur et bénéficiaire de la loi et comme sujet de droit.",
    text: "Interroger les limites des libertés individuelles.",
  },
  {
    id: "EPC-P3-696f9ab7",
    champ: "",
    section: "6. Comprendre les principes de la démocratie",
    kind: "Savoir-faire",
    parent: "Reconnaitre tout citoyen comme auteur et bénéficiaire de la loi et comme sujet de droit.",
    text: "Interroger l’égalité en termes de droits et de devoirs.",
  },
  {
    id: "EPC-P3-7bf0aa9b",
    champ: "",
    section: "6. Comprendre les principes de la démocratie",
    kind: "Savoir-faire",
    parent: "Reconnaitre l’égalité devant la loi.",
    text: "Questionner l’importance d’avoir des règles qui garantissent les droits.",
  },
  {
    id: "EPC-P3-cd5d243f",
    champ: "",
    section: "6. Comprendre les principes de la démocratie",
    kind: "Savoir-faire",
    parent: "Saisir le sens des différents pouvoirs, leur champ d’application et leurs rôles respectifs.",
    text: "Identifier qui décide des règles, à qui elles s’appliquent et qui veille à leur respect.",
  },
  {
    id: "EPC-P3-fc13bfdc",
    champ: "",
    section: "6. Comprendre les principes de la démocratie",
    kind: "Savoir-faire",
    parent: "Reconnaitre le droit à l’information et la liberté de la presse en démocratie.",
    text: "Questionner les effets des médias (information/ manipulation) sur ses jugements, ses comportements et ceux des autres.",
  },
  {
    id: "EPC-P3-917234b3",
    champ: "",
    section: "6. Comprendre les principes de la démocratie",
    kind: "Savoir-faire",
    parent: "Critiquer l’atteinte aux droits et les abus de pouvoir.",
    text: "Identifier des situations d’atteinte à la dignité, aux droits (discrimination, moquerie, rejet, exclusion, maltraitance, harcèlement...) et les moyens de s’y opposer.",
  },
  {
    id: "EPC-P3-2a11b292",
    champ: "",
    section: "6. Comprendre les principes de la démocratie",
    kind: "Compétence",
    parent: "Comprendre les principes de la démocratie.",
    text: "Identifier ce qui caractérise une pratique démocratique.",
  },
  {
    id: "EPC-P3-d26b5cc6-2",
    champ: "",
    section: "7. S’exercer au processus démocratique",
    kind: "Savoir",
    parent: "Règles-lois-normes.",
    text: "Identifier-exemplifier : distinguer différents types de règles et de normes.",
  },
  {
    id: "EPC-P3-a83464aa",
    champ: "",
    section: "7. S’exercer au processus démocratique",
    kind: "Savoir-faire",
    parent: "Construire le cadre du débat.",
    text: "Élaborer le cadre du débat (espace, règles, objet et finalité).",
  },
  {
    id: "EPC-P3-e9e282ca",
    champ: "",
    section: "7. S’exercer au processus démocratique",
    kind: "Savoir-faire",
    parent: "Construire le cadre du débat.",
    text: "Mettre en œuvre le cadre du débat.",
  },
  {
    id: "EPC-P3-cb18abf3",
    champ: "",
    section: "7. S’exercer au processus démocratique",
    kind: "Savoir-faire",
    parent: "Débattre collectivement.",
    text: "Formuler des arguments en lien avec le débat.",
  },
  {
    id: "EPC-P3-2f98a568",
    champ: "",
    section: "7. S’exercer au processus démocratique",
    kind: "Savoir-faire",
    parent: "Débattre collectivement.",
    text: "Exprimer son accord ou son désaccord.",
  },
  {
    id: "EPC-P3-42b40b1c",
    champ: "",
    section: "7. S’exercer au processus démocratique",
    kind: "Savoir-faire",
    parent: "Débattre collectivement.",
    text: "Assumer différents rôles.",
  },
  {
    id: "EPC-P3-d4dee9e9",
    champ: "",
    section: "7. S’exercer au processus démocratique",
    kind: "Savoir-faire",
    parent: "Débattre collectivement.",
    text: "Dégager collectivement des idées du débat.",
  },
  {
    id: "EPC-P3-42c32b6f",
    champ: "",
    section: "7. S’exercer au processus démocratique",
    kind: "Savoir-faire",
    parent: "Décider collectivement.",
    text: "Conclure/décider ensemble à l’issue d’un débat.",
  },
  {
    id: "EPC-P3-286c6036",
    champ: "",
    section: "7. S’exercer au processus démocratique",
    kind: "Savoir-faire",
    parent: "Décider collectivement.",
    text: "Découvrir et expérimenter différents processus de décision (consensus, compromis, vote, élections périodiques…).",
  },
  {
    id: "EPC-P3-2ab12d1f",
    champ: "",
    section: "7. S’exercer au processus démocratique",
    kind: "Compétence",
    parent: "S’exercer au processus démocratique.",
    text: "S’exercer au débat dans le cadre collectivement établi.",
  },
  {
    id: "EPC-P3-866ab340-3",
    champ: "",
    section: "8. S’inscrire dans la vie sociale et politique",
    kind: "Savoir",
    parent: "Entraide-coopération.",
    text: "Identifier-exemplifier.",
  },
  {
    id: "EPC-P3-0461d5c9",
    champ: "",
    section: "8. S’inscrire dans la vie sociale et politique",
    kind: "Savoir-faire",
    parent: "S’informer en vue de s’inscrire dans la vie sociale et politique.",
    text: "S’informer pour questionner l’impact de ses gestes quotidiens.",
  },
  {
    id: "EPC-P3-8f9f2924",
    champ: "",
    section: "8. S’inscrire dans la vie sociale et politique",
    kind: "Savoir-faire",
    parent: "Coopérer pour s’inscrire dans la vie sociale et politique.",
    text: "Se coordonner, s’entraider, solliciter de l’aide pour soi, pour les autres et pour tous. Questionner les forces et les limites de la coopération.",
  },
  {
    id: "EPC-P3-24559eb4",
    champ: "",
    section: "8. S’inscrire dans la vie sociale et politique",
    kind: "Savoir-faire",
    parent: "Imaginer une société et/ou un monde meilleur(s).",
    text: "À partir de sujets de société, imaginer des alternatives.",
  },
  {
    id: "EPC-P3-a9eeb280",
    champ: "",
    section: "8. S’inscrire dans la vie sociale et politique",
    kind: "Compétence",
    parent: "S’inscrire dans la vie sociale et politique.",
    text: "Imaginer des possibilités de coopération et d’action.",
  },
];
